export interface ITransportType {
    id: number,
    description: string,
    defaultPrice: number,
    oboPrice: number
}